import { forwardRef } from 'react';

import { RangeDatePicker } from './RangeDatePicker';
import { SingleDatePicker } from './SingleDatePicker';
import { DatePickerProps } from './types';

export const DatePicker = forwardRef<HTMLButtonElement, DatePickerProps>((props, ref) => {
  if (props.mode === 'single') {
    return <SingleDatePicker {...props} ref={ref} />;
  }

  return <RangeDatePicker {...props} ref={ref} />;
});

DatePicker.displayName = 'DatePicker';
